import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { ToastContainer, toast } from 'react-toastify';
import '../Admindashboard.css'

function Deliquents({ IP, TOKEN }) {

    const [data, setData] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [fsBatches, setFsBatches] = useState([])
    const [selectedBatch, setSelectedBatch] = useState(1)

    useEffect(() => {
        fetchFsBatchNames()
    }, [])

    const fetchDeliquents = (batch) => {
        setLoading(true)
        let parameters = { fsbatchid: batch, token: TOKEN }
        axios.post(`http://${IP}/getbatchwisedeliquents`, parameters)
            .then(res => {
                if (res.data.error === true) {
                    notifyError(res.data.msg)
                }
                if (res.data.error === false) {
                    setData(res.data.msg.batchwisedeliquents)
                    setLoading(false)
                }
            })
            .catch(e => console.log(e))
    }

    useEffect(() => {
        fetchDeliquents(1)
    }, [])

    const fetchFsBatchNames = async () => {
        await axios.get(`http://${IP}/fs-all-batch-names/${TOKEN}`)
            .then(res => {
                setFsBatches(res.data.FSBatches)
            })
            .catch(err => console.log(err))
    }

    const columns = [
        { field: 'htno', headerName: 'Roll No', width: 150 },
        { field: 'attpercentage', headerName: 'Attendance Percentage', width: 180 },
    ];

    const notifyError = (msg) => {
        toast.error(msg, {
            toastId: 3,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    return (
        <div>
            <FormControl sx={{ minWidth: 170, mt: 3 }} size="small">
                <InputLabel id="fsbatch">Select FS Batch</InputLabel>
                <Select
                    labelId="fsbatch"
                    id="fsbatch"
                    value={selectedBatch}
                    label="Select FS Batch"
                    onChange={(event) => { fetchDeliquents(event.target.value); setSelectedBatch(event.target.value) }}
                >
                    {
                        fsBatches.map((obj) =>
                            <MenuItem value={obj.id} key={obj.id}>
                                {obj.name}
                            </MenuItem>
                        )
                    }
                </Select>
            </FormControl>
            <div className='datagrid-deliquents' style={{ height: 550, width: '100%', marginTop: '20px', backgroundColor: 'white' }}>
                <DataGrid
                    getRowId={(obj) => obj.htno}
                    loading={isLoading}
                    rows={data}
                    columns={columns}
                    components={{ Toolbar: GridToolbar }}
                />
            </div>
            <ToastContainer />
        </div>
    );
}

export default Deliquents;